export const personalinfo = 2;
export const resume = 3;
export const payroll = 4;
export const employmentinfo = 5;
export const timeandattendance = 6;
export const benefitsandcobra = 7;
export const other = 8;
//export const addnotes = 9;
